<template>
  <section class="content reporting-row">

    <div class="form-group col-sm-4">
      <label>Dates</label>
      <treeselect class="tree-select" v-if="reporting.availableDates"
                  ref="treeDates"
                  :multiple="true"
                  v-model="reporting.filters.daysList"
                  :searchable="true"
                  :options="reporting.availableDates"
                  sortValueBy="LEVEL"
                  :default-expand-level="1"
                  :limit="3"
                  :limitText="count => `et ${count} de plus`"
                  :max-height="500"
                  placeholder="Dates sélectionnées"
                  :allways-opened="false"
                  v-on:change="dateChanged()"
                  @input="dateChanged">
      </treeselect>
    </div>

    <div class="form-group col-sm-4">


      <label>Matériel</label>
      <treeselect class="tree-select" v-if="reporting.availableMateriel"
                  ref="treeMateriel"
                  :multiple="true"
                  v-model="reporting.filters.idsMateriel"
                  :searchable="true"
                  :options="reporting.availableMateriel"
                  :default-expand-level="0"
                  :limit="3"
                  :limitText="count => `et ${count} de plus`"
                  :max-height="500"
                  placeholder="Matériels sélectionnés"
                  :allways-opened="false"
                  v-on:change="materielChanged()"
                  @input="materielChanged">
        <option></option>
      </treeselect>
    </div>
    <div class="form-group col-sm-4">
      <label>Agent</label>
      <treeselect class="tree-select" v-if="reporting.availableAgents"
                  ref="treeAgents"
                  :multiple="true"
                  v-model="reporting.filters.idAgent"
                  :options="reporting.availableAgents"
                  sortValueBy="LEVEL"
                  :default-expand-level="1"
                  :limit="3"
                  :limitText="count => `et ${count} de plus`"
                  :max-height="500"
                  placeholder="Agents sélectionnés"
                  :allways-opened="false"
                  v-on:change="agentChanged()"
                  @input="agentChanged">
      </treeselect>
    </div>
    <div class="col-sm-2 pull-right">
      <label>&nbsp;</label>
      <button type="button" v-on:click="generateReporting(1)" class="btn btn-block export-btn">
        Exporter
      </button>
    </div>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import state from '../../../store/state'

export default {
  components: {Treeselect},
  methods: {
    generateReporting: function (mode) {
      switch (mode) {
        case 1:
          this.$store.dispatch('generateReporting', this.reporting.filters)
          break
      }
    },
    dateChanged: function () {
      this.$store.dispatch('updateReportingMaterielFilter')
      this.reloadAgents()
    },
    materielChanged: function () {
      this.extractIds(this.$store.state.reporting.filters.idsMateriel)
      if (this.reporting.filters.daysList.length === 0) {
        this.$store.dispatch('updateReportingDatesFilter')
      }
      this.reloadAgents()
    },
    agentChanged: function () {
      console.log('deb-fil ha ach kayn => ', this.$store.state.reporting.filters.idAgent)
      if (this.$store.state.reporting.filters.idAgent[0] === '1') {
        let ids = []
        state.reporting.availableAgents[0].children.forEach(function (agent) {
            ids.push(agent.id)
        })
        state.reporting.filters.idAgent = ids
      }
    },
    reloadAgents: function () {
      this.$store.state.reporting.filters.idAgent = []
      this.$store.dispatch('updateReportingAgentFilter')
    },
    extractIds: function (materiels) {
      let ids = []

      let mat = materiels.find(item => item === '1' || item === '2-0' || item === '2-1')

      if (mat === '1') {
        state.reporting.availableMateriel[0].children.forEach(function (arrondissement) {
          arrondissement.children.forEach(function (materiel) {
            ids.push(materiel.id)
          })
        })
        state.reporting.filters.idsMateriel = ids

      } else if (mat === '2-0') {
        state.reporting.availableMateriel[0].children[0].children.forEach(function (materiel) {
          ids.push(materiel.id)
        })
        if (state.reporting.filters.idsMateriel.length === 0) {
          state.reporting.filters.idsMateriel = ids
        } else {
          state.reporting.filters.idsMateriel = state.reporting.filters.idsMateriel.concat(ids)
          state.reporting.filters.idsMateriel = state.reporting.filters.idsMateriel.filter(item => item !== '2-1' && item !== '2-0')
        }
      } else if (mat === '2-1') {
        state.reporting.availableMateriel[0].children[1].children.forEach(function (materiel) {
          ids.push(materiel.id)
        })
        if (state.reporting.filters.idsMateriel.length === 0) {
          state.reporting.filters.idsMateriel = ids
        } else {
          state.reporting.filters.idsMateriel = state.reporting.filters.idsMateriel.concat(ids)
          state.reporting.filters.idsMateriel = state.reporting.filters.idsMateriel.filter(item => item !== '2-1' && item !== '2-0')
        }
      }

    }
  },
  computed: {
    ...mapState([
      'reporting',
    ]),
  },
  mounted: async function () {
    this.$store.dispatch('fetchMaterielsOfVille')
    this.$store.dispatch('fetchCantonniersOfVille')
    this.$store.dispatch('getSecteursOfVille')

    await this.$store.dispatch('getAvailableMateriels')
    await this.$store.dispatch('getAvailableCantonniers')
    await this.$store.dispatch('getAvailableDates')

    console.log('Actual filter => ', this.reporting.filters.daysList)

    this.dateChanged()
    //this.$store.dispatch('fetchReportingV2')
  },
}
</script>

<style lang="scss">
@import '../../../scss/variables';

.row.reporting-row {
  align-items: start;
}

button:hover {
  color: #fff !important;
}

button.export-btn {
  background-color: $suez-blue;
  background-image: url('/static/img/icon-dl.svg');
  background-repeat: no-repeat;
  background-position: 15px center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: none;
  padding: 7px 15px 8px 45px;

}

button.export-btn-fte {
  background-color: $suez-blue;
  background-image: url('/static/img/icon-dl-green.svg');
  background-repeat: no-repeat;
  background-position: 15px center;
  color: #aadc14;
  font-size: 14px;
  font-weight: bold;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: none;
  padding: 7px 15px 8px 45px;

}

</style>



// WEBPACK FOOTER //
// Reporting.vue?f0580358